import styles from './index.module.scss';

/**
 * 他のカテゴリごとのアコーディオンのProps
 * @param title カテゴリ名
 * @param children カテゴリごとの1軸項目リスト
 */
interface Props {
  title: string;
  children: React.ReactNode;
}

export const OtherJobContentInfoByCategory: React.FC<Props> = ({
  title,
  children,
}) => {
  return (
    <div className={styles.otherJobContentInfo__category}>
      <h3 className={styles.otherJobContentInfo__categoryTitle}>{title}</h3>
      <div className={styles.otherJobContentInfo__MiddleAccordionListItem}>
        {children}
      </div>
    </div>
  );
};
